import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";

export const Logo = () => {
  return (
    <div className="brand navbar-brand">
      <Link to="/" className="brand navbar-brand">
        <img src={logo} alt="NCRR" />
      </Link>
    </div>
  );
};
